import request from '../../requests/requests';
import { Api } from '../../config/api';
import { configs } from '../../config/config';

export function GetRoleList(data){
    return request({
        url:Api.role.list,
        method:configs.http.request.methodGet,
        data
    })
}

export function EditRole(data) {
    return request({
        url:Api.role.edit+data.id,
        method:configs.http.request.methodPut,
        data
    })
}

export function GetRoleById(data){
    return request({
        url:Api.role.info+data.id,
        method:configs.http.request.methodGet,
        data
    })
}

export function CreateRole(data){
    return request({
        url:Api.role.create,
        method:configs.http.request.methodPost,
        data
    })
}

